import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Page, PageTitle } from "@/components/common/page";
import { PageSkeleton } from "@/components/common/states";
import { AuditTable } from "@/components/logs/audit-table";
import { qForProject } from "@/data/queries";

export const Route = createFileRoute("/p/$project/logs")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(qForProject(params.project).auditEvents()),
  pendingComponent: PageSkeleton,
  component: LogsPage,
});

function LogsPage() {
  const q = qForProject(Route.useParams().project);
  const { data: events } = useSuspenseQuery(q.auditEvents());
  return (
    <Page wide>
      <PageTitle
        title="Logs"
        description="Everything a person, a key or Aux0 itself did, with the request id support will ask you for."
      />
      {events.truncated ? (
        <p role="status">
          Showing the latest 200 events. Older events may exist; the API has no
          pagination yet.
        </p>
      ) : null}
      <AuditTable events={events.items} />
    </Page>
  );
}
